import { render, staticRenderFns } from "./ordonnance_client.vue?vue&type=template&id=48f435cc&"
import script from "./ordonnance_client.vue?vue&type=script&lang=js&"
export * from "./ordonnance_client.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports